export default "__VITE_ASSET__CnsOJbE4__"